import { render, staticRenderFns } from "./entry-team-roster.vue?vue&type=template&id=3e43b19c&scoped=true&"
import script from "./entry-team-roster.vue?vue&type=script&lang=js&"
export * from "./entry-team-roster.vue?vue&type=script&lang=js&"
import style0 from "./entry-team-roster.vue?vue&type=style&index=0&id=3e43b19c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e43b19c",
  null
  
)

export default component.exports